// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Congo - Kinshasa */
const CD = /^(?:88\d{5}|(?:8[0-69]|9[016-9])\d{7})$/;

export default CD;
